import * as Yup from "yup";

export const loginSchema = Yup.object({
  email: Yup.string()
    .transform((value) => value ? value.trim() : value)
    .email("Invalid email")
    .required("Email is required")
    .test('no-whitespace', 'Email should not contain leading or trailing spaces', (value) => {
      if (!value) return true;
      return value === value.trim();
    }),
  password: Yup.string()
    .required("Please enter your password")
    .test('not-empty', 'Please enter your password', (value) => {
      return value && value.trim().length > 0;
    })
    .min(5, "Password must be at least 5 characters"),
});

export const sendOtpSchema = Yup.object({
  email: Yup.string().email("Invalid email").required("Email is required"),
});

export const addUserSchema = Yup.object().shape({
  fullName: Yup.string().required('Name is required'),
  email: Yup.string().email('Invalid email').required('Email is required'),
  mobileNumber: Yup.string().matches(/^[0-9]+$/, 'Must be only digits').required('Mobile number is required').min(10, 'Mobile number must be at least 10 digits'),
  bio: Yup.string(),
  accountStatus: Yup.string().notOneOf(['select'], 'Please select a status').required('Status is required'),
  subscriptionStatus: Yup.string().notOneOf(['select'], 'Please select a subscription status').required('Subscription status is required')
});

export const reportSchema = Yup.object().shape({
  subject: Yup.string().required('Subject is required'),
  content: Yup.string().required('Content is required'),
});
